module.exports = __webpack_public_path__ + "static/img/contract2.83a17cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract2.png
// module id = rQlg
// module chunks = 1